import { useCallback, useMemo, useState, type ReactNode } from "react";

import {
  AppShellBreadcrumbContext,
  type AppShellBreadcrumbContextValue,
  type AppShellBreadcrumbItem,
} from "./AppShellBreadcrumbContext";

export function ColocaAppShellBreadcrumbProvider({ children }: { children: ReactNode }) {
  const [items, setItemsState] = useState<AppShellBreadcrumbItem[]>([]);

  const setItems = useCallback((next: AppShellBreadcrumbItem[]) => {
    setItemsState(next);
  }, []);

  const value = useMemo<AppShellBreadcrumbContextValue>(() => ({ items, setItems }), [items, setItems]);

  return <AppShellBreadcrumbContext.Provider value={value}>{children}</AppShellBreadcrumbContext.Provider>;
}
